<script lang="ts">
	import { page } from '$app/stores';
	import { tabletModeStore } from '$lib/stores/tablet-mode-store';
	import { userRole } from '$lib/stores/auth-store';
	import { createEnum } from '$lib/utils/utils';
	import { PermissionService, featureTypes } from '$lib/utils/permissions-helper';
	import type { ComponentType, SvelteComponent } from 'svelte';
	import { resolve } from '$app/paths';

	const GROUPNAMES = createEnum({
		Navigasjon: 'Navigasjon',
		Admin: 'Admin',
		Profil: 'Profil'
	});

	type MenuItem = {
		title: string;
		url: string;
		visibleForRole: Array<'SuperAdmin' | 'Standardbruker' | 'Administrator' | undefined>;
		visibleInContext: Array<'Desktop' | 'Tablet'>;
		targetBlank?: boolean;
		group: keyof typeof GROUPNAMES;
		component?: ComponentType<SvelteComponent>;
		permission?: keyof typeof featureTypes;
	};

	export let includeCategories: string[];
	export let groupName: string;
	export let menuItemsGrouped: {
		[key: typeof groupName]: MenuItem[];
	};
</script>

{#if includeCategories.includes(groupName)}
	{#if menuItemsGrouped[groupName].filter( (item) => item.visibleForRole.includes($userRole) ).length && groupName !== 'Profil'}
		<p class="label pl-0! mt-4">
			<span class="label-text">
				{groupName}
			</span>
		</p>
	{/if}
	<div class="gap-y-3 divide-y divide-secondary/10">
		{#if menuItemsGrouped[groupName].length}
			{#each menuItemsGrouped[groupName] as menuItem (menuItem.url)}
				{@const displayMenuItemInContext =
					(!$tabletModeStore && menuItem.visibleInContext.includes('Desktop')) ||
					($tabletModeStore && menuItem.visibleInContext.includes('Tablet'))}
				{#if menuItem.visibleForRole.includes($userRole) && displayMenuItemInContext && (!menuItem.permission || PermissionService.can(menuItem.permission))}
					<div class="">
						<a
							class="border-transparent hover:border-gray-300 w-full text-sm px-2 py-2 my-1 flex items-center gap-x-3 relative duration-100 {$page.url.pathname.includes(
								menuItem.url
							)
								? 'font-semibold text-primary active-menulink'
								: 'text-secondary hover:text-secondary/75 hover:bg-primary/15 font-medium rounded-md'}"
							data-sveltekit-preload-data
							href={resolve(menuItem.url)}
							target={menuItem.targetBlank ? '_blank' : null}
							rel="noreferrer"
						>
							{#if menuItem.component}
								<svelte:component this={menuItem.component} size={24} />
							{/if}
							<span>
								{menuItem.title}
							</span>
						</a>
					</div>
				{/if}
			{/each}
		{/if}
	</div>
{/if}
